import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper/Paper';
import Loading from '../../../../Common/Loading';
import styles from '../styles';

const TaskCountTile = ({ data: { count, start } }) => {
  return (<Paper style={styles.tasksContainer}>
    <div style={styles.paperTitle}>Current Tasks</div>
    <div style={styles.paperBody}>{count >= 0 ? count : <Loading/>}</div>
    {start ? <Typography variant="caption">Since {moment(start).format('lll')}</Typography> : null }
  </Paper>);
};

export default TaskCountTile;



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingView/tiles/TaskCountTile.js